/* eslint-disable */
import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import useSimpleHousehold from "Hooks/useSimpleHousehold";
import Snapshot from "Components/UI/Snapshot/Snapshot";

const SnapshotContainer = () => {
    const { householdResource } = useSimpleHousehold();

    return (
        <DataContainer
            component={Snapshot}
            loading={!householdResource}
        />
    );
};

export default SnapshotContainer;
